import { z } from "zod";
import { IdSchema } from "../common/primitives.js";
const SEARCH_KINDS = ["projects", "clients", "documents", "tasks", "messages"];
const SearchKindSchema = z.enum(SEARCH_KINDS);
const SEARCH_SCOPES = ["all", ...SEARCH_KINDS];
const SearchQuerySchema = z.strictObject({
  q: z.string().trim().min(2).max(100),
  scope: z.enum(SEARCH_SCOPES).default("all"),
  /** Results per kind. */
  limit: z.coerce.number().int().min(1).max(20).default(5)
});
const HighlightSchema = z.array(z.strictObject({ text: z.string(), match: z.boolean() }));
const SearchHitSchema = z.strictObject({
  kind: SearchKindSchema,
  id: IdSchema,
  title: z.string(),
  /** Project or document code. */
  code: z.string().nullable(),
  projectId: IdSchema.nullable(),
  spaceId: IdSchema.nullable(),
  folderId: IdSchema.nullable(),
  /**
   * Message hits only (COM-BE-03): `id` is the message, `title` a snippet of its text around the
   * match, `spaceId` the channel's space. The client opens
   * `/o/{orgId}/chat/{channelId}?message={id}`.
   */
  channelId: IdSchema.nullable().optional(),
  /** Null for a direct chat (name it after the other person). */
  channelName: z.string().nullable().optional(),
  highlight: HighlightSchema,
  /**
   * Document hits with content search on (GEDX-BE-02, OpenSearch): the passage of the document's
   * text (or its OCR) that matched, with the matched words marked; absent otherwise.
   */
  snippet: HighlightSchema.optional()
});
const SearchResultSchema = z.strictObject({
  groups: z.array(
    z.strictObject({
      kind: SearchKindSchema,
      items: z.array(SearchHitSchema),
      /** More results exist than `limit`. */
      hasMore: z.boolean()
    })
  )
});
const START = "";
const STOP = "";
const HIGHLIGHT_MARKERS = { start: START, stop: STOP };
function highlightSegments(marked) {
  const segments = [];
  let match = false;
  let current = "";
  for (const char of marked) {
    if (char === START || char === STOP) {
      if (current) segments.push({ text: current, match });
      current = "";
      match = char === START;
    } else current += char;
  }
  if (current) segments.push({ text: current, match });
  return segments;
}
export {
  HIGHLIGHT_MARKERS,
  HighlightSchema,
  SEARCH_KINDS,
  SEARCH_SCOPES,
  SearchHitSchema,
  SearchKindSchema,
  SearchQuerySchema,
  SearchResultSchema,
  highlightSegments
};
//# sourceMappingURL=index.js.map